<template>
    <div class="favourite-button" @click="toggleFavourite" :class="{'is-active': active}">
        <SmrTooltip :content="tooltips ? (active ? tooltips.full.content : tooltips.empty.content) : ''" :position="tooltips ? (active ? tooltips.full.position : tooltips.empty.position) : ''">
            <Icon v-if="!loading">
                <IconStar v-if="active"/>
                <IconStarOutline v-if="!active"/>
            </Icon>
        </SmrTooltip>
        <Loader v-if="loading"/>
    </div>
</template>

<script>
import eventBus from '@/utils/event-bus';
import { mapGetters } from 'vuex'
import Icon from '@/components/Icon.vue'
import IconStar from '@/components/icons/IconStar.vue'
import IconStarOutline from '@/components/icons/IconStarOutline.vue'
import Loader from '@/components/Loader.vue'
import SmrTooltip from '@/components/SmrTooltip.vue'
import messageBoxBlueprint from '@/mixins/message-box-blueprint.js';
import { trackEvent, trackGa4Event } from '@/utils/tracking'

export default {
    components: {
        Icon,
        IconStar,
        IconStarOutline,
        Loader,
        SmrTooltip
    },
    mixins: [messageBoxBlueprint],
    props: {
        favouriteObject: {
            type: Object,
            default: () => {}
        },
        tooltips: {
            type: [Object, Boolean],
            default: () => {}
        },
        trackingData: {
            type: [Object, Boolean],
            default: false
        },
    },
    data() {
        return {
            loading: false,
            routeSaved: false
        }
    },
    mounted() {
        this.addListeners()
    },
    beforeDestroy() {
        this.removeListeners()
    },
    computed: {
        ...mapGetters(['user', 'allFavourites', 'isSavedRoute', 'savedRouteInfo']),
        favouriteId() {
            if(this.active) return this.filteredFavourite[0]?.id
            return false
        },
        filteredFavourite() {
            if(!this.favouriteObject) return false
            const id = this.favouriteObject.locationId ?? this.favouriteObject.id
            // TODO: no ID means it is a mapbox result -> find a way to compare it
            if(!id) {
                return false
            }
            if(id === 'home' || id === 'work') {
                return this.allFavourites.filter(favourite => favourite.id.includes(id))
            }
            if(this.favouriteObject.category === 'ADDRESS') {
                return this.allFavourites.filter(favourite => id === favourite.id || id === favourite.objectId)
            }
            return this.allFavourites.filter(favourite => id === favourite.objectId)
        },
        active() {
            return this.filteredFavourite.length > 0 || this.routeSaved || this.isSavedRoute;
        }
    },
    methods: {
        activeRouteSavedHandler() {
            this.routeSaved = true
        },
        addListeners() {
            eventBus.$on('activeRouteSaved', this.activeRouteSavedHandler)
        },
        removeListeners() {
            eventBus.$off('activeRouteSaved', this.activeRouteSavedHandler)
        },
        toggleFavourite() {
            const confirmationType = this.isSavedRoute ? 'route': 'favourite'
            if(this.active) {
                eventBus.$emit('showFavouriteRemovalConfirmation', () => { 
                    if (this.isSavedRoute) {
                        this.$store.dispatch('resetSavedRouteSettings', false) // to turn star inactive immediately
                        this.$store.dispatch('removeSavedRoute', this.savedRouteInfo.id)
                    } else {
                        this.deleteFavourite() 
                    }
                }, confirmationType)
            } else {
                eventBus.$emit('showFavouritesPanel', this.favouriteObject);
                if(this.trackingData) {
                    trackEvent(this.trackingData)
                    trackGa4Event(this.trackingData)
                }
            }
        },
        deleteFavourite() {
            this.$store.dispatch('removeFavourite', {
                favouriteId: this.favouriteId,
                objectId: this.favouriteObject.id,
            })
        }
    },
}
</script>

<style lang="scss">
.favourite-button {
    transition: color 0.2s;
    cursor: pointer;
    color: $color-grey-dark;
    .no-touch &:hover {
        color: $color-black;
    }
}
</style>